import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { mergeBlogContent } from './content/siteCopyHelpers';
import { useSiteSettings } from './SiteSettingsContext';
import { brandNameFromSettings, storeSeo } from './siteBrand';

export default function BlogPage() {
  const { settings: site } = useSiteSettings();
  const blogContent = useMemo(() => mergeBlogContent(site.blog_content), [site.blog_content]);
  const brandName = brandNameFromSettings(site);
  const seo = storeSeo(site, 'seo_blog_title', blogContent.section_title, 'Tips for choosing jewelry and festive gifting from our studio.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="store-page blog-page">
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
      </Helmet>
      <div className="container store-page__container py-4 py-lg-5">
        <header className="store-page__header utility-page__header text-center">
          <p className="shop-hero-eyebrow">{brandName}</p>
          <h1 className="store-page__title section-title mb-2">{blogContent.section_title}</h1>
          <p className="store-page__lead mx-auto mb-0">{blogContent.section_subtitle}</p>
        </header>
        <div className="row g-4 blog-page__grid">
          {blogContent.posts.map((post) => (
            <div className="col-md-4 d-flex" key={post.slug}>
              <article className="blog-card w-100 h-100">
                <div className="blog-card-body">
                  <h2 className="blog-card-title h5">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>
                  <p className="blog-card-text">{post.excerpt}</p>
                  <Link to={`/blog/${post.slug}`} className="blog-card-link">
                    Read more
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
